export const URL_API = process.env.REACT_APP_API_URL || 'http://localhost:10001';
export const URL_WS = process.env.REACT_APP_WS_URL || 'http://localhost:10004';
// POS Bridge chạy cục bộ trên PC kế toán (loopback, cổng cố định). Override qua env khi cần.
export const URL_POS_BRIDGE = process.env.REACT_APP_POS_BRIDGE_URL || 'http://127.0.0.1:8790';